import React from "react";
import {Text} from "@unibuddy/patron";
import {ErrorBoundary, useErrorReporting} from "@unibuddy/error-reporting";

import {AssistantInitiationProvider} from "./views/Chat/providers/AssistantInitiationProvider";
import {Chat} from "./views/Chat/Chat";
import {AppWrapper} from "./components/AppWrapper";
import {AssistantConversationProvider} from "./views/Chat/providers/AssistantConversationProvider";
import {AppCTAButton} from "./views/CTA/AppCTAButton";
import {AppCTAActions} from "./views/CTAActions/AppCTAActions";
import {ScreensizeProvider} from "./providers/ScreensizeProvider";
import {SocketWrapperProvider} from "./providers/SocketWrapperProvider";
import {MobileMenuProvider} from "./providers/MobileMenuProvider";

export function Root() {
    const {reportError} = useErrorReporting();
    const urlParams = new URLSearchParams(window.location.search);
    const render = urlParams.get("render");

    switch (render) {
        case "cta":
            return (
                <ErrorBoundary fallback={null}>
                    <AppCTAButton />
                </ErrorBoundary>
            );

        case "ctaActions":
            return (
                <ScreensizeProvider>
                    <ErrorBoundary fallback={null}>
                        <AppCTAActions />
                    </ErrorBoundary>
                </ScreensizeProvider>
            );

        case "chat":
            return (
                <ScreensizeProvider>
                    <ErrorBoundary
                        fallback={
                            <Text size="medium" align="center">
                                Could not load Unibuddy Assistant. Please try again later.
                            </Text>
                        }
                    >
                        <SocketWrapperProvider>
                            <MobileMenuProvider>
                                <AppWrapper>
                                    <AssistantInitiationProvider>
                                        <AssistantConversationProvider>
                                            <Chat />
                                        </AssistantConversationProvider>
                                    </AssistantInitiationProvider>
                                </AppWrapper>
                            </MobileMenuProvider>
                        </SocketWrapperProvider>
                    </ErrorBoundary>
                </ScreensizeProvider>
            );

        default:
            reportError(new Error(`Invalid render: '${render ?? "null"}'`));
            return null;
    }
}
